"use strict";
/**
 * Created by rouven on 22.02.17.
 */
exports.__esModule = true;
exports.FORM_ERROR_SET = void 0;
var PREFIX = '@@wikom-form/';
exports.FORM_ERROR_SET = PREFIX + 'FORM_ERROR_SET';
